import React, { useCallback, useEffect, useState } from 'react';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { MultiSelect } from 'primereact/multiselect';
import { SelectButton } from 'primereact/selectbutton';
// Asegúrate de que PrimeIcons esté importado en tu proyecto principal, por ejemplo en index.js o App.js:
// import 'primeicons/primeicons.css';
import './FilterComponent.scss';
import UnidadesDisponiblesModal from './UnidadesDisponiblesModal';
import { getClients } from '../../../monitoreo/MonitoreoServicios/MonitoreoServiciosIntegracion';
import { getProveedores, transferisServiciosIntegracion } from '../../../monitoreo/TransferirServicios/transferisServiciosIntegracion';
import { getAllOperadores, getRutes } from '../../Rutas/RutasIntegracion';
import { getTipoUnidad } from '../../Exepciones/ExcepcionesIntegracion';
import { formateoBasico } from '../../../../utilities/formateos';
import { Checkbox } from 'primereact/checkbox';

const FilterComponent = ({
    fecha,
    setFecha,
    cliente,
    setCliente,
    proveedor,
    setProveedor,
    ruta,
    setRuta,
    operador,
    setOperador,
    unidad,
    setUnidad,
    tipoUnidad,
    setTipoUnidad,
    handleConsultar,
    params,
    clear,
    setSelectedFilterType,
    selectedFilterType,
    zona,
    setZona,
    setSelectedColumns,
    selectedColumns,
    setKmCalculado,
    kmCalculado

}) => {
    const [clientes, setClientes] = useState([]);
    const [proveedores, setProveedores] = useState([]);
    const [rutas, setRutas] = useState([]);
    const [operadores, setOperadores] = useState([]);
    const [tiposUnidades, setTiposUnidades] = useState([]);
    const [showFilters, setShowFilters] = useState(true);
    const [showUnidadesModal, setShowUnidadesModal] = useState(false);

    const columns = [
        { name: 'ID', code: 'ID' },
        { name: 'OPERADOR', code: 'OPERADOR' },
        { name: 'UNIDAD', code: 'UNIDAD' },
        { name: 'UNIDAD_TIPO', code: 'UNIDAD_TIPO' },
        { name: 'SERVICIOS', code: 'SERVICIOS' },
        { name: 'HORAS', code: 'HORAS' },
        { name: 'RUTA', code: 'RUTA' },
        { name: 'KM', code: 'KM' },
        { name: 'PAGO', code: 'PAGO' },
        { name: 'ESTATUS', code: 'ESTATUS' },
    ];

    useEffect(() => {
        setSelectedColumns([
            { name: 'OPERADOR', code: 'OPERADOR' },
            { name: 'UNIDAD', code: 'UNIDAD' },
            { name: 'UNIDAD_TIPO', code: 'UNIDAD_TIPO' },
            { name: 'RUTA', code: 'RUTA' },
            { name: 'SERVICIOS', code: 'SERVICIOS' },
        ])
    }, [])


    useEffect(() => {
        getClients(setClientes);
        transferisServiciosIntegracion.getProveedores(setProveedores);
        getAllOperadores(setOperadores);
        getTipoUnidad(setTiposUnidades);
    }, []);

    useEffect(() => {
        if (cliente) {
            transferisServiciosIntegracion.getRutesByIdClient(cliente.code, setRutas);
        } else {
            setRutas([]);
        }
    }, [cliente]);

    useEffect(() => {
        if (selectedFilterType) {
            // Lógica si necesitas recargar rutas basada en 'ruta' seleccionada (podría ser redundante)
            onConsultar()
        }

    }, [selectedFilterType]);

    const onConsultar = useCallback(() => {
        const currentParams = {
            fecha: fecha ? fecha.toISOString().split('T')[0] : null,
            cliente: cliente ? cliente.code : null,
            proveedor: proveedor ? proveedor.code : null,
            // Solo se enviará el filtro activo según el radio button seleccionado
            operador: selectedFilterType === 'operador' ? (operador ? operador.code : null) : null,
            ruta: selectedFilterType === 'ruta' ? (ruta ? ruta.code : null) : null,
            unidad: selectedFilterType === 'unidad' ? (unidad || null) : null,
            tipoUnidad: tipoUnidad ? tipoUnidad.code : null,
            // Indicador del tipo de filtro seleccionado, si es necesario para la API
            selectedFilterType: selectedFilterType,
            km_wialon: kmCalculado
        };
        handleConsultar(currentParams);
    }, [fecha, cliente, proveedor, operador, ruta, unidad, tipoUnidad, selectedFilterType, kmCalculado]);

    const onClear = useCallback(() => {
        setFecha(null);
        setCliente(null);
        setProveedor(null);
        setRuta(null);
        setOperador(null);
        setUnidad(null);
        setTipoUnidad(null);
        setSelectedFilterType('operador'); // Limpiar la selección de radio button
        clear();
    }, []);

    const vistaOptions = [
        { label: 'Maestro', value: 'maestro', icon: 'pi pi-table' },
        { label: 'Detalles', value: 'detalles', icon: 'pi pi-chart-bar' }
    ];

    const vistaTemplate = (option) => {
        return (
            <span>
                <i className={option.icon} style={{ marginRight: '5px' }}></i>
                {option.label}
            </span>
        );
    };
    
    return (
        <div className="filters-section-container">
            <div className="containerContractor">
                {
                    showFilters ?
                        <i className="pi pi-chevron-circle-up" onClick={() => setShowFilters(!showFilters)}></i>
                        :
                        <i className="pi pi-chevron-circle-down" onClick={() => setShowFilters(!showFilters)}></i>
                }
            </div>
            {
                showFilters ?
                    <div>
                        <div className="filters-card">
                            <div className="filter-field">
                                <label htmlFor="fecha">Fecha</label>
                                <Calendar id="fecha" value={fecha} onChange={(e) => setFecha(e.value)} dateFormat="dd/mm/yy" />
                            </div>

                            <div className="filter-field">
                                <label htmlFor="proveedor">Proveedor</label>
                                <Dropdown filter optionLabel='name' id="proveedor" value={proveedor} options={proveedores} onChange={(e) => setProveedor(e.value)} placeholder="Proveedor" />
                            </div>
                            <div className="filter-field">
                                <label htmlFor="cliente">Cliente</label>
                                <Dropdown filter optionLabel='name' id="cliente" value={cliente} options={clientes} onChange={(e) => setCliente(e.value)} placeholder="Cliente" />
                            </div>

                            <div className="filter-field">
                                <label htmlFor="ruta">Ruta</label>
                                <Dropdown
                                    filter
                                    optionLabel='name'
                                    id="ruta"
                                    value={ruta}
                                    options={rutas}
                                    onChange={(e) => setRuta(e.value)}
                                    placeholder="Ruta"
                                />
                            </div>

                            <div className="filter-field">
                                <label htmlFor="operador">Operador</label>
                                <Dropdown
                                    filter
                                    optionLabel='name'
                                    id="operador"
                                    value={operador}
                                    options={operadores}
                                    onChange={(e) => setOperador(e.value)}
                                    placeholder="Operador"
                                />
                            </div>

                            <div className="filter-field">
                                <label htmlFor="unidad">Unidad</label>
                                <InputNumber
                                    id="unidad"
                                    value={unidad}
                                    onChange={(e) => setUnidad(e.value)}
                                    placeholder="Unidad"
                                />
                            </div>

                            <div className="filter-field">
                                <label htmlFor="tipoUnidad">Tipo Unidad</label>
                                <Dropdown filter optionLabel='name' id="tipoUnidad" value={tipoUnidad} options={tiposUnidades} onChange={(e) => setTipoUnidad(e.value)} placeholder="Tipo Unidad" />
                            </div>

                            {/* *** RADIO BUTTONS PARA FILTRAR POR *** */}
                            <div className="filter-radio-group flex-between">
                                <div className='flex'>

                                    <label>Filtrar por:</label>
                                    <div className="p-field-radiobutton">
                                        <RadioButton inputId="rbOperador" name="filterType" value="operador" onChange={(e) => setSelectedFilterType(e.value)} checked={selectedFilterType === 'operador'} />
                                        <label htmlFor="rbOperador">Operador</label>
                                    </div>
                                    <div className="p-field-radiobutton">
                                        <RadioButton inputId="rbRuta" name="filterType" value="ruta" onChange={(e) => setSelectedFilterType(e.value)} checked={selectedFilterType === 'ruta'} />
                                        <label htmlFor="rbRuta">Ruta</label>
                                    </div>
                                    <div className="p-field-radiobutton">
                                        <RadioButton inputId="rbUnidad" name="filterType" value="unidad" onChange={(e) => setSelectedFilterType(e.value)} checked={selectedFilterType === 'unidad'} />
                                        <label htmlFor="rbUnidad">Unidad</label>
                                    </div>
                                </div>

                                <div className="p-field-radiobutton">
                                    
                                    <Checkbox tooltipOptions={{ position: 'left',showOnDisabled: true}}  tooltip={selectedFilterType === 'operador' ? `Solo puede acceder a esta opcion filtrando por ruta o unidad` : ''} disabled={selectedFilterType === 'operador'} name="filterType" value={kmCalculado} onChange={(e) => setKmCalculado(e.checked)} checked={kmCalculado === true} />
                                    <label htmlFor="kmCalculado">KM calculado</label>
                                </div>
                                
                            </div>

                            <div style={{ display: 'flex', gap: "20px", justifyContent: "space-between", alignItems: "center", width: "100%" }}>


                                <div className="filter-actions-group">
                                    <MultiSelect style={{ margin: '10px' }} value={selectedColumns} onChange={(e) => setSelectedColumns(e.value)} options={columns} optionLabel="name"
                                        placeholder="Selecciona una columna" maxSelectedLabels={3} className="w-full md:w-20rem" />
                                    <Button label="Consultar" icon="pi pi-search" onClick={onConsultar} className="p-button-raised consult-button" />
                                    <Button label="Limpiar" onClick={onClear} className="p-button-raised clear-button" />
                                    <Button
                                        label="Unidades Disponibles"
                                        icon="pi pi-car"
                                        onClick={() => setShowUnidadesModal(true)}
                                        className="p-button-raised p-button-info"
                                        style={{ margin: '10px' }}
                                    />
                                </div>
                                {/* *** BOTONES TOGGLE PARA VISTA *** */}
                                <div className="filter-vista-buttons" style={{ marginTop: '15px', marginBottom: '15px' }}>
                                    <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>Vista:</label>
                                    <SelectButton
                                        value={zona}
                                        options={vistaOptions}
                                        onChange={(e) => setZona(e.value)}
                                        itemTemplate={vistaTemplate}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="legend-card">
                            <h3>Colores de servicios</h3>
                            <div className="color-items-container">
                                <div className="color-item">
                                    <div className="color-box color-error"></div>
                                    <i className="pi pi-exclamation-triangle"></i>
                                    <span>ERROR EN LA PROGRAMACIÓN</span>
                                </div>
                                <div className="color-item">
                                    <div className="color-box color-empresarial"></div>
                                    <i className="pi pi-briefcase"></i>
                                    <span>SERVICIO EMPRESARIAL</span>
                                </div>
                                <div className="color-item">
                                    <div className="color-box color-taller"></div>
                                    <i className="pi pi-wrench"></i>
                                    <span>VISITA TALLER</span>
                                </div>
                                <div className="color-item">
                                    <div className="color-box color-administrativo"></div>
                                    <i className="pi pi-home"></i>
                                    <span> VISITA OFICINA Y GUARDIAS</span>
                                </div>
                                <div className="color-item">
                                    <div className="color-box color-especial"></div>
                                    <i className="pi pi-star"></i>
                                    <span>SERVICIO ESPECIAL</span>
                                </div>
                                <div className="color-item">
                                    <div className="color-box color-en-curso"></div>
                                    <span>ESTADO EN CURSO</span>
                                </div>
                                <div className="color-item">
                                    <div className="color-box color-terminado"></div>
                                    <span>ESTADO TERMINADO</span>
                                </div>
                                <div className="color-item">
                                    <div className="color-box color-confirmado"></div>
                                    <span>ESTADO CONFIRMADO</span>
                                </div>
                                <div className="color-item">
                                    <div className="color-box color-programada"></div>
                                    <span>ESTADO PROGRAMADA</span>
                                </div>
                            </div>

                            {/* <h3>Definición de Acrónimos</h3>
                    <ul className="acronym-items-container">
                        <li className="acronym-item"><b>ST:</b> <span>SERVICIOS TRASLAPADOS</span></li>
                        <li className="acronym-item"><b>T U E:</b> <span>TIPO UNIDAD DE ESTRUCTURA</span></li>
                        <li className="acronym-item"><b>ESPECIAL:</b> <span>SERVICIO ESPECIAL</span></li>
                        <li className="acronym-item"><b>VACACIONES:</b> <span>OPERADOR VACACIONES</span></li>
                        <li className="acronym-item"><b>PERMISO:</b> <span>OPERADOR PERMISO</span></li>
                        <li className="acronym-item"><b>INCAPACIDAD:</b> <span>OPERADOR INCAPACIDAD</span></li>
                        <li className="acronym-item"><b>DESCANSO:</b> <span>OPERADOR DESCANSO</span></li>
                        <li className="acronym-item"><b>BAJA:</b> <span>OPERADOR CON FECHA DE BAJA</span></li>
                    </ul> */}
                        </div>
                    </div>
                    : <div style={{ marginTop: "2rem" }}></div>
            }

            <UnidadesDisponiblesModal
                visible={showUnidadesModal}
                onHide={() => setShowUnidadesModal(false)}
                fecha={formateoBasico(fecha)}
                tiposUnidades={tiposUnidades}
            />
        </div>
    );
};

export default FilterComponent;